/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Snap_To_Shot_Changes_FailedInputs */



/**
* | output |
* | --- |
* | "Snap To shot changes failed with message: {error}" |
*
* @param {Snap_To_Shot_Changes_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_failed = /** @type {((inputs: Snap_To_Shot_Changes_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’alignement sur les changements de plan : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Snap-To-Aufnahmeänderungen fehlgeschlagen mit der Meldung: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Modifiche Snap To shot non riuscite con messaggio: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Изменения в снимке Snap To не удались, сообщение об ошибке: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Los cambios en Ajustar a la toma fallaron con el mensaje: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`快照更改失败，错误信息：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スナップ ショットの変更が失敗しました。メッセージ: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्नैप टू शॉट में बदलाव विफल हो गए, संदेश आया: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A alteração de disparo automático falhou com a mensagem: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Snap To shot changes failed with message: ${i?.error}`)
});